import AcxDialog from "components/UI/Dialog/AcxDialog";
import React from "react";
import { observer } from "mobx-react";
import { useCurrentDashboard } from "../../useCurrentDashboard";
import { Grid } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import { useNavigate } from "react-router";
import { useStore } from "utils/useStore";
import SignalsPageStore from "../../Store/SignalsPageStore";

// Dialog component for confirming the deletion of a dashboard
// SIGNALSTODO - change to the normal AcxConfirmDeleteDialog
export const DashboardConfirmDelete = observer(
    ({
        open,
        setOpen,
    }: {
        open: boolean;
        setOpen: (open: boolean) => void;
    }) => {
        const currentDashboard = useCurrentDashboard();
        const signalsPageStore = useStore(SignalsPageStore);
        const navigate = useNavigate();

        if (!currentDashboard) {
            return null;
        }

        return (
            <AcxDialog
                isOpen={open}
                onClose={() => {
                    setOpen(false);
                }}
                title="Confirm Delete Dashboard"
                subTitle={`Are you sure you want to delete dashboard '${currentDashboard.title}'?`}
                children={
                    <Grid container item xs={4}>
                        <AcxButton
                            fullWidth
                            color="error"
                            loading={signalsPageStore.getTaskLoading(
                                "DeleteDashboard",
                            )}
                            sx={{
                                width: "115px",
                                border: "1px solid",
                                height: "32px",
                            }}
                            onClick={async () => {
                                const deleted =
                                    await signalsPageStore.deleteDashboard(
                                        currentDashboard.id,
                                    );
                                if (deleted) {
                                    setOpen(false);
                                    navigate("/app/signals");
                                }
                            }}
                        >
                            Confirm Delete
                        </AcxButton>
                    </Grid>
                }
            />
        );
    },
);
